import { render, staticRenderFns } from "./stopOrder.vue?vue&type=template&id=6a200636&"
import script from "./stopOrder.vue?vue&type=script&lang=js&"
export * from "./stopOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports